import React from 'react';
import PropTypes from 'prop-types';
import styled from '@mui/styles/styled';

const Container = styled('div')({
	whiteSpace: 'nowrap',
	height: 42,
});

function CellRowItem({ children }) {
	let row1;
	let row2;

	if (Array.isArray(children)) {
		[row1, row2] = children;
	} else {
		row1 = children;
	}

	return (
		<Container>
			<div>{row1}</div>
			<div>{row2}</div>
		</Container>
	);
}

CellRowItem.propTypes = {
	children: PropTypes.node.isRequired,
};

export default React.memo(CellRowItem);
